import React, {FunctionComponent, TextareaHTMLAttributes, useEffect, useRef, useState} from "react";
import "./AnswerBox.scss";
import TypeAnswer from "./TypeAnswer";
import FormDislikedFeedback from "./FormDislikedFeedback";
import RephraseAnswer from "./RephraseAnswer";
import {GeneratedAnswerStyle} from "@coveo/headless";
interface Props {
    controller: any,
    globalSearchBoxCGRAController: any;
}
const AnswerBox: FunctionComponent<Props> = (props) => {
    const {controller, globalSearchBoxCGRAController} = props;
    const [stateAnswer, setStateAnswer] = useState(controller.state);
    const [activeFeedback, setActiveFeedback] = useState("");
    const [activeLikedUi, setActiveLikedUi] = useState(false);
    const [activeDislikedUi, setActiveDislikedUi] = useState(false);
    const [showMoreButton, setShowMoreButton] = useState(false);
    const [showLikedFeedback, setShowLikedFeedback] = useState(false);
    const [showDislikedFeedback, setShowDislikedFeedback] = useState(false);
    const [timeOutMessage, setTimeOutMessage] = useState(0);
    const [rephraseClicked, setRephraseClicked] = useState(false);
    const [isRephraseContentLoading, setIsRephraseContentLoading] = useState(false);
    const [isButtonShowMoreActive, setIsButtonShowMoreActive] = useState(false);
    const url_string = decodeURI(window.location.href);
    const url = new URL(url_string);
    let setTimeTriggerLiked = 0
    let setTimeTriggerDisliked = 0
    let keyWord = url.searchParams.get("q") || "";
    useEffect(() => {
        setActiveDislikedUi(stateAnswer.disliked);
    }, [stateAnswer.disliked]);

    useEffect(() => {
        setActiveDislikedUi(false);
        if (stateAnswer.expanded || showMoreButton) {
            setShowMoreButton(false);
        }
        controller.subscribe(() => {
            const url_string = decodeURI(window.location.href);
            const url = new URL(url_string);
            let keyWord = url.searchParams.get("q") || "";
            if (globalSearchBoxCGRAController.state.value === keyWord) {
                setStateAnswer(controller.state);
                setActiveLikedUi(controller.state.liked);
            }
            //flag check is check click button show more
            //@ts-ignore
            window.expandClick = false
        });
    }, []);
    useEffect(() => {
        setRephraseClicked(false);
        setShowMoreButton(false);
        setIsButtonShowMoreActive(false);
    }, [globalSearchBoxCGRAController.state.value]);
    useEffect(() => {
        if (isRephraseContentLoading && !controller.state.isLoading && !controller.state.isAnswerGenerated) {
            setIsRephraseContentLoading(false);
        }
    }, [controller.state.isLoading]);
    const handleLikedButton = (e: any) => {
        setActiveFeedback(!showLikedFeedback ? e.currentTarget.value : "");
        setShowLikedFeedback(!showLikedFeedback);
        if (timeOutMessage > 0) {
            window.clearTimeout(timeOutMessage);
        }
        if (setTimeTriggerLiked > 0) {
            window.clearTimeout(setTimeTriggerLiked);
        }
        let hideMessage = window.setTimeout(() => {
            setShowLikedFeedback(false);
            window.clearTimeout(hideMessage);
        }, 5000);
        setTimeOutMessage(hideMessage);
        setActiveDislikedUi(false);
        setActiveLikedUi(!activeLikedUi);
        setTimeTriggerLiked = window.setTimeout(() => {
            let likeBtn = document.querySelector(".like-button");
            if (likeBtn!.classList.contains("active")) {
                controller.like();
            }
            clearTimeout(setTimeTriggerLiked);
        }, 3000);
    }

    const handleDislikedButton = (e: any) => {
        setActiveFeedback(!activeDislikedUi ? e.currentTarget.value : "");
        setShowDislikedFeedback(!showDislikedFeedback);
        setActiveLikedUi(false);
        setActiveDislikedUi(!activeDislikedUi);
        if (stateAnswer.feedbackSubmitted) {
            if (timeOutMessage > 0) {
                clearTimeout(timeOutMessage);
            }
            let hideMessage = window.setTimeout(() => {
                setShowDislikedFeedback(false);
                clearTimeout(hideMessage);
            }, 5000);
            setTimeOutMessage(hideMessage);
        }
        if (setTimeTriggerDisliked > 0) {
            window.clearTimeout(setTimeTriggerDisliked);
        }
        setTimeTriggerDisliked = window.setTimeout(() => {
            let dislikeBtn = document.querySelector(".dislike-button");
            if (dislikeBtn!.classList.contains("active")) {
                controller.dislike();
            }
            window.clearTimeout(setTimeTriggerDisliked);
        }, 3000);
    }

    const handleClickCitationUrl = (e: any) => {
        e.preventDefault();
        let currentElement = e.currentTarget;
        if (currentElement.href) {
            window.open(currentElement.href, "__blank");
        }
        controller.logCitationClick(e.currentTarget.id);
        //@ts-ignore
        window.citationUrl = e.currentTarget.href;
    }

    const onChangeAnswerStyle = (answerStyle: GeneratedAnswerStyle) => {
        if (stateAnswer?.responseFormat.answerStyle !== answerStyle) {
            if (isButtonShowMoreActive) {
                setRephraseClicked(true);
            }
            setIsRephraseContentLoading(true);
            controller?.rephrase({
                ...stateAnswer?.responseFormat,
                answerStyle,
            });
        }
    }

    const handleExpandAnswer = (e:any) => {
        controller.expand();
        setShowMoreButton(false);
        setIsButtonShowMoreActive(true);
        //@ts-ignore
        window.expandClick = true;
    }

    const body = document.getElementsByTagName('body')[0];
    body.onclick = (e: any) => {
        if (showDislikedFeedback && e.target.id !== "dislike-feedback" && !e.target.closest("#dislike-feedback")) {
            setShowDislikedFeedback(false);
        }
        if (showLikedFeedback) {
            setShowLikedFeedback(false);
        }
    };
    if (!isRephraseContentLoading && (globalSearchBoxCGRAController.state.value !== keyWord || !stateAnswer.isAnswerGenerated)) {
        return (<></>);
    }
    let classContainer = "answer-box-container";
    if (!rephraseClicked && showMoreButton) {
        classContainer += " showButtonExpand";
    }
    if (isRephraseContentLoading) {
        classContainer += " loading-content";
    }
    return (
        <div className={classContainer}>
            <div className="answer-box-wrapper">
                <div className="answer-buttons">
                    <div className="generated-answer-label">Generated Answer</div>
                    <div className="feedback-button">
                        <div className={"btn-feedback" + (activeFeedback == "liked" && activeLikedUi && showLikedFeedback ? " active" : "")}>
                            <button className={activeFeedback == "liked" && activeLikedUi ? "like-button active" : "like-button"} value="liked" onClick={handleLikedButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" fill="none" viewBox="0 0 14 14" height="30" width="30">
                                    <path id="path1" strokeLinejoin="round" strokeLinecap="round" stroke="currentColor" d="m 11.00003,8.49978 h 0.5 c 0.55229,0 1,0.44771 1,1 v 0 c 0,0.55228 -0.44771,1 -1,1 L 10,10.49996 h 1 c 0.55228,0 0.99999,0.44771 1,1 v 0 c 0,0.55228 -0.44772,1 -1,1 H 9.5 l -3.52786,-6e-5 c -0.31049,0 -0.61672,-0.07229 -0.89443,-0.21115 L 3.5,11.4999 m 0,-6.5 c 0,-0.2761 -0.2239,-0.5 -0.5,-0.5 H 1 c -0.2761,0 -0.5,0.2239 -0.5,0.5 v 7 c 0,0.27614 0.2239,0.5 0.5,0.5 h 2 c 0.2761,0 0.5,-0.22386 0.5,-0.5 v -0.5 -6.5 h 0.9415 c 0.3471,10e-6 0.6694,-0.18 0.85145,-0.4755 L 6.48493,2.5895 C 6.49482,2.5735 6.50005,2.555 6.50005,2.5361 L 6.50004,1.477 C 6.50004,0.9374 6.93748,0.5 7.47709,0.5 v 0 c 0.32669,0 0.63296,0.165 0.81417,0.4368 v 0 C 8.7432,1.6147 8.91025,2.4487 8.75047,3.2476 L 8.5000098,4.498621 12.5,4.497321 c 0,0 1,-0.07687 1,0.9999998 0,0.983123 -1,1 -1,1 l -2.460584,0.00258 h 2 c 0.55228,0 1,0.44772 1,1 v 0 c 0,0.55228 -0.44772,1 -1,1 h -2" className="line"></path>
                                </svg>
                            </button>
                            <p className="message">Thank you for sharing your feedback.</p>
                        </div>
                        <div className={"btn-feedback" + (activeFeedback == "disliked" && activeDislikedUi && showDislikedFeedback ? " active" : "")}>
                            <button className={activeFeedback == "disliked" && activeDislikedUi ? "dislike-button active" : "dislike-button"} value="disliked" onClick={handleDislikedButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" fill="none" viewBox="0 0 14 14" height="30" width="30">
                                    <path id="path1" strokeLinejoin="round" strokeLinecap="round" stroke="currentColor" d="m 11.00003,8.49978 h 0.5 c 0.55229,0 1,0.44771 1,1 v 0 c 0,0.55228 -0.44771,1 -1,1 L 10,10.49996 h 1 c 0.55228,0 0.99999,0.44771 1,1 v 0 c 0,0.55228 -0.44772,1 -1,1 H 9.5 l -3.52786,-6e-5 c -0.31049,0 -0.61672,-0.07229 -0.89443,-0.21115 L 3.5,11.4999 m 0,-6.5 c 0,-0.2761 -0.2239,-0.5 -0.5,-0.5 H 1 c -0.2761,0 -0.5,0.2239 -0.5,0.5 v 7 c 0,0.27614 0.2239,0.5 0.5,0.5 h 2 c 0.2761,0 0.5,-0.22386 0.5,-0.5 v -0.5 -6.5 h 0.9415 c 0.3471,10e-6 0.6694,-0.18 0.85145,-0.4755 L 6.48493,2.5895 C 6.49482,2.5735 6.50005,2.555 6.50005,2.5361 L 6.50004,1.477 C 6.50004,0.9374 6.93748,0.5 7.47709,0.5 v 0 c 0.32669,0 0.63296,0.165 0.81417,0.4368 v 0 C 8.7432,1.6147 8.91025,2.4487 8.75047,3.2476 L 8.5000098,4.498621 12.5,4.497321 c 0,0 1,-0.07687 1,0.9999998 0,0.983123 -1,1 -1,1 l -2.460584,0.00258 h 2 c 0.55228,0 1,0.44772 1,1 v 0 c 0,0.55228 -0.44772,1 -1,1 h -2" className="line"></path>
                                </svg>
                            </button>
                            {stateAnswer.feedbackSubmitted && (<p className="message">Thank you for sharing your feedback.</p>)}
                            {!stateAnswer.feedbackSubmitted && (
                                <FormDislikedFeedback
                                    setActiveDislikedUi={setActiveDislikedUi}
                                    submitForm={controller.sendFeedback}
                                    setShowDislikedFeedback={setShowDislikedFeedback}
                                    setTimeOutMessage={setTimeOutMessage}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className={(!rephraseClicked && showMoreButton) ? "answer-content-wrap collapsed" : "answer-content-wrap"}>
                    <div className="answer-content">
                        {!stateAnswer.isStreaming && stateAnswer.answer && (
                            <TypeAnswer text={stateAnswer.answer} delay={300} showMoreButton={showMoreButton} showButtonExpand={setShowMoreButton}/>
                        )}
                    </div>
                    <div className="answer-footer">
                        {stateAnswer.citations.length > 0 && (
                            <div className="citations-container">
                                <div className="citations-title">Reference citations:</div>
                                <div className="citations-list">
                                    {stateAnswer.citations.map((item:any, index:number) => {
                                        let url = item.fields.product_url || item.fields.sfpublicurl__c || item.clickUri;
                                        if (url.search("http") === -1) {
                                            url = "https://" + url;
                                        }
                                        let title = item.title;
                                        let fullTitle:  string | undefined;
                                        if (title.length > 60) {
                                            fullTitle = item.title;
                                            title = fullTitle?.substring(0, 57) + "...";
                                        }
                                        return (
                                            <div className="citation-item" key={index}>
                                                <a id={item.id} className="citation-link" href={url} title={fullTitle} onClick={handleClickCitationUrl}>
                                                    <span className="item-order">{index + 1}</span>
                                                    {title}
                                                </a>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                        <RephraseAnswer currentStyle={stateAnswer?.responseFormat.answerStyle} onChangeStyle={onChangeAnswerStyle} />
                    </div>
                </div>
                {!rephraseClicked && showMoreButton && (
                    <div className="answer-showmore">
                        <div className="blur-gradient"></div>
                        <div className="answer-showmore-btn-wrap">
                            <button className="answer-showmore-btn" onClick={handleExpandAnswer}>Show more <span className="icon-showmore">d</span> </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
export default AnswerBox;